import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { Icon } from "../../../../Icons/Icon";

export const Action = styled("div")<{ visible: boolean }>(props => ({
    display: props.visible ? "block" : "none",
}));

export interface MenuItemContentProps {
    active?: boolean;
    childActive?: boolean;
    empty?: boolean;
    collapsible: boolean;
}

export const MenuItemRoot = styled.li(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
}));

export const Content = styled.div<MenuItemContentProps>(
    props => ({
        lineHeight: "24px",
        cursor: props.active || props.childActive ? "default" : "pointer",
        padding: props.collapsible ? "6px 4px 6px 0" : "4px 4px 4px 18px",
        borderRadius: "8px",

        ":hover": {
            backgroundColor: theme(props).lists.items.accentLow.backgroundColor,

            [`${Action}`]: {
                display: "block",
            },
        },
    }),
    props =>
        props.childActive && {
            backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
        },
    props =>
        props.active && {
            backgroundColor: theme(props).lists.items.accentHigh.backgroundColor,
            color: theme(props).typography.primary.color,

            ":hover": {
                backgroundColor: theme(props).lists.items.accentHigh.backgroundColor,
            },

            [`${Action}`]: {
                display: "block",
            },
        },
    props =>
        props.empty && {
            color: theme(props).lists.items.default.secondaryColor,
        }
);

export const CollapseIcon = styled(Icon)({
    display: "inline-block",
    transition: "transform 0.2s ease",
});

export const CollapseIconButton = styled.button<{ collapsed: boolean }>(props => ({
    display: "inline-block",
    border: 0,
    outline: 0,
    padding: 0,
    color: theme(props).lists.items.default.secondaryColor,
    fontSize: "12px",
    lineHeight: "20px",
    backgroundColor: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    width: 18,
    cursor: "pointer",

    ":hover": {
        backgroundColor: "transparent",
        color: theme(props).typography.primary.color,
    },

    [`${CollapseIcon}`]: {
        transform: props.collapsed ? "rotate(-90deg)" : undefined,
    },
}));

export const Row = styled.div({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
});

export const UnitItemTitle = styled.div<{ childActive: boolean }>(
    () => ({
        display: "flex",
        alignItems: "baseline",
        minWidth: 0,
        marginRight: 5,
        flexGrow: 1,
        flexShrink: 1,
    }),
    props =>
        props.childActive && {
            color: theme(props).typography.primary.color,
        }
);

export const Name = styled.span({
    overflowWrap: "anywhere",
});

export const MultipleIndex = styled.div(props => ({
    minWidth: 0,
    flexGrow: 0,
    flexShrink: 0,
    color: theme(props).lists.items.default.secondaryColor,
    marginRight: "4px",
}));

export const ExtraInfo = styled.div<{ paddingLeft?: number }>(props => ({
    minWidth: 0,
    flexGrow: 0,
    flexShrink: 0,
    color: theme(props).lists.items.default.secondaryColor,
    paddingLeft: props.paddingLeft,
}));

export const ActionWrapper = styled.div({
    flexBasis: 20,
    flexGrow: 0,
    flexShrink: 1,
});
